// components/HeaderCard.tsx
import React from "react";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { IThirdPartyService, INTEGRATED_SERVICE } from "request";
// import { Spinner } from "components";

interface HeaderCardProps {
  connectService: IThirdPartyService | undefined;
  isAuthorized: boolean;
  isAuthLoading: boolean;
  onConnect: () => void;
  publicPath?: string;
}

export const HeaderCard: React.FC<HeaderCardProps> = ({
  connectService,
  isAuthorized,
//   isAuthLoading,
  // onConnect,
  publicPath,
}) => {
  const renderServiceTitle = () => {
    if (isAuthorized) {
      return <FormattedMessage id="thirdParty.connect.success" />;
    }

    switch (connectService?.showFlag) {
      case INTEGRATED_SERVICE.alexa:
        return <FormattedMessage id="thirdParty.connect.alexa.title" />;
      case INTEGRATED_SERVICE.googleAssistant:
        return (
          <FormattedMessage id="thirdParty.connect.google.assistant.title" />
        );
      case INTEGRATED_SERVICE.appleHealth:
        return <FormattedMessage id="thirdParty.connect.apple.health.title" />;
      case INTEGRATED_SERVICE.googleFit:
        return <FormattedMessage id="thirdParty.connect.google.fit.title" />;
      case INTEGRATED_SERVICE.healthConnect:
        return (
          <FormattedMessage id="thirdParty.connect.health.connect.title" />
        );
      default:
        return null;
    }
  };

  const renderServiceTip = () => {
    return connectService?.showFlag === INTEGRATED_SERVICE.alexa ? (
      <p className="px-4 pt-3 text-xs text-gray999">
        <FormattedMessage id="thirdParty.connect.alexa.tip" />
      </p>
    ) : null;
  };

  return (
    <div className={clsx("bg-white dark:bg-gray323434 rounded py-7")}>
      <div className="flex flex-row items-center justify-center gap-12">
        <img
          src={`${publicPath}/icons/ic_logo.png`}
          className="w-[54px]"
          alt="Logo"
        />
        <img
          src={`${publicPath}/icons/ic_link.png`}
          className="w-5"
          alt="Link"
        />
        {connectService?.image && (
          <img
            src={connectService?.image}
            className="w-[54px]"
            alt={connectService?.name}
          />
        )}
      </div>
      <p className="px-8 mt-6 text-center max-w-[340px] md:max-w-full w-full mx-auto">
        {renderServiceTitle()}
      </p>
      {renderServiceTip()}
    </div>
  );
};

